// extracted by mini-css-extract-plugin
export default {"upload":"upload__08c6e44a","preview":"preview__08c6e44a"};